import { createAnalyticsGroup } from 'js/lib/analytics'

if (document.querySelectorAll('.js-c-just-listed-image').length) {
  document.querySelectorAll('.js-analytics-tracking').forEach(el => {
    const track = createAnalyticsGroup('UnavailableGroup')

    const label = el.getAttribute('data-analytics-label') || 'unknown link'
    el.addEventListener('click', () => {
      track('click', label)
    })
  })
}
